
import { Name } from "../prm/name";
import { OptionMenu } from "../prm/option-menu";


const states = [
  new Name("AZ", "AZ"),
  new Name("CA", "CA"),
  new Name("ID", "ID"),
  new Name("IL", "IL"),
  new Name("LA", "LA"),
  new Name("NM", "NM"),
  new Name("NV", "NV"),
  new Name("PR", "PR"),
  new Name("TX", "TX"),
  new Name("WA", "WA"),
  new Name("WI", "WI"),
];

class CommunityPropertyMenu extends OptionMenu {

  constructor(name) {
    super(name, states)
  }
}

export { CommunityPropertyMenu };
